import React from 'react';
import { Logo } from '../components/Logo';
import { Phone, MapPin, Clock, Lock, ShieldAlert } from 'lucide-react';

export const UnderConstruction: React.FC = () => {
  return (
    <div className="min-h-screen bg-darker text-white flex flex-col justify-between p-6 md:p-12 relative overflow-hidden font-sans">
      {/* Background Ambient Glow */}
      <div className="absolute top-1/4 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[500px] h-[500px] bg-primary/10 rounded-full blur-[120px] pointer-events-none"></div>
      <div className="absolute bottom-1/4 left-1/3 -translate-x-1/2 w-[300px] h-[300px] bg-danger/5 rounded-full blur-[100px] pointer-events-none"></div>

      {/* Header Accent Line */}
      <div className="absolute top-0 left-0 right-0 h-1.5 flex">
        <div className="flex-1 bg-primary"></div>
        <div className="w-1/3 bg-accent"></div>
        <div className="w-1/4 bg-danger"></div>
      </div>

      {/* Top Bar */}
      <div className="flex justify-between items-center z-10">
        <div className="flex items-center gap-2 bg-black/40 backdrop-blur-md border border-gray-800 px-4 py-2 rounded-full">
          <span className="h-2 w-2 rounded-full bg-amber-500 animate-ping"></span>
          <span className="text-[10px] uppercase tracking-[0.2em] font-extrabold text-amber-500">Inventory Sync Active</span>
        </div>
        <a 
          href="#/admin" 
          className="flex items-center gap-2 text-gray-500 hover:text-white transition-colors bg-white/5 hover:bg-white/10 px-4 py-2 rounded-full text-[10px] uppercase tracking-widest font-bold border border-white/5 transition-all"
        >
          <Lock size={12} className="text-primary" />
          <span>Staff Login</span>
        </a>
      </div>

      {/* Center Hero Card */}
      <div className="max-w-2xl mx-auto my-auto text-center z-10 py-12 animate-fade-in-up">
        <div className="flex justify-center mb-8">
          <Logo variant="light" size="xl" />
        </div>

        <div className="inline-flex items-center gap-2.5 px-5 py-2.5 rounded-2xl bg-gradient-to-r from-primary/10 to-danger/10 border border-primary/20 mb-8 shadow-xl shadow-black/40">
          <ShieldAlert size={16} className="text-accent animate-pulse" />
          <span className="text-xs uppercase tracking-[0.25em] font-extrabold text-white">Catalog Under Construction</span>
        </div>

        <h1 className="text-4xl md:text-5xl font-heading font-extrabold uppercase tracking-tight text-white mb-6 leading-tight">
          We're Tuning Our <br />
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-primary via-accent to-danger">Online Showroom</span>
        </h1>

        <p className="text-gray-400 text-sm md:text-base leading-relaxed max-w-lg mx-auto mb-10 font-medium">
          Dakar Auto Sales is currently performing systems maintenance and updating our active vehicle catalog. We will be back live shortly with fresh premium arrivals.
        </p>

        {/* Quick Contact Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 text-left max-w-xl mx-auto bg-black/30 backdrop-blur-md border border-white/5 p-6 rounded-3xl">
          <div className="flex flex-col gap-1.5 p-3 rounded-2xl hover:bg-white/5 transition-all">
            <span className="text-primary font-bold text-xs uppercase tracking-widest flex items-center gap-1.5">
              <Phone size={12} /> Call Us
            </span>
            <a href="tel:7738639999" className="text-white font-extrabold text-sm hover:text-accent transition-colors">
              +1 773-863-9999
            </a>
          </div>

          <div className="flex flex-col gap-1.5 p-3 rounded-2xl hover:bg-white/5 transition-all sm:border-l sm:border-white/5">
            <span className="text-danger font-bold text-xs uppercase tracking-widest flex items-center gap-1.5">
              <MapPin size={12} /> Address
            </span>
            <span className="text-white font-extrabold text-xs">
              6115 S Ashland Ave,<br />Chicago, IL
            </span>
          </div>

          <div className="flex flex-col gap-1.5 p-3 rounded-2xl hover:bg-white/5 transition-all sm:border-l sm:border-white/5">
            <span className="text-accent font-bold text-xs uppercase tracking-widest flex items-center gap-1.5">
              <Clock size={12} /> Business Hours
            </span>
            <span className="text-white font-extrabold text-xs">
              Mon-Sat: 9am - 7pm<br />Sunday: Closed
            </span>
          </div>
        </div>
      </div>

      {/* Footer Branding */}
      <div className="text-center z-10 text-[10px] text-gray-600 uppercase tracking-[0.3em] font-bold">
        © {new Date().getFullYear()} Dakar Auto Sales • Chicago, IL
      </div>
    </div>
  );
};
